import React from "react";
// import SakuraEffectComp from "../component/SakuraEffectComp";
import ThemeShowsComp from "../component/ThemeShowsComp";
import { Container } from "react-bootstrap";
import FaqComp from "../component/FaqComp";
import FooterComp from "../component/FooterComp";
import MitraComp from "../component/MitraComp";
import NavbarComp from "../component/NavbarComp";
import HeroComp from "../component/HeroComp";

export default function Homepage() {
  const images = [
    {
      image:
        "https://image.invb.my.id/63cbdc410c4fee3502af8aa9/images/1774324877489-nod2jtdvne.jpg",
      link: "https://vintation.com/theme/690ea2fe1d5034e0faac5d64",
    },
    {
      image:
        "https://image.invb.my.id/63cbdc410c4fee3502af8aa9/images/1774324898937-n0d2lb8not.jpg",
      link: "https://vintation.com/theme/690ea3091d5034e0faac5d66",
    },
    {
      image:
        "https://image.invb.my.id/63cbdc410c4fee3502af8aa9/images/1774325308349-zmkdqa1ofye.jpg",
      link: "https://vintation.com/theme/690ea32a1d5034e0faac5d6c",
    },
    {
      image:
        "https://image.invb.my.id/63cbdc410c4fee3502af8aa9/images/1774325427771-2rlxibhjurt.jpg",
      link: "https://vintation.com/theme/6964a926400f2f08d2b2ec71",
    },
    {
      image:
        "https://image.invb.my.id/63cbdc410c4fee3502af8aa9/images/1774327481807-eqpkvolj3f.jpg",
      link: "https://vintation.com/theme/690ea3301d5034e0faac5d6e",
    },
    {
      image:
        "https://image.invb.my.id/63cbdc410c4fee3502af8aa9/images/1774327650440-tzgsl26bkk.jpg",
      link: "https://vintation.com/theme/695f7ba3400f2f08d2b2ea94",
    },
    {
      image:
        "https://image.invb.my.id/63cbdc410c4fee3502af8aa9/images/1774328081170-co5idl7bon7.jpg",
      link: "https://vintation.com/theme/67382ed30a364d08bb3cab8c",
    },
    {
      image:
        "https://image.invb.my.id/63cbdc410c4fee3502af8aa9/images/1774327666295-taxx3l349mm.jpg",
      link: "https://vintation.com/theme/690ea33e1d5034e0faac5d70",
    },
    {
      image:
        "https://image.invb.my.id/63cbdc410c4fee3502af8aa9/images/1774330014656-q8nfi28x9f.jpg",
      link: "https://vintation.com/theme/675e48604c179909458f622a",
    },
  ];
  const images2 = [
    {
      image:
        "https://image.invb.my.id/63cbdc410c4fee3502af8aa9/images/1774327436673-dojrfhdtqx7.jpg",
      link: "https://vintation.com/theme/674151fa0dd31808bc316dfc",
    },
    {
      image:
        "https://image.invb.my.id/63cbdc410c4fee3502af8aa9/images/1774327511712-h0cpfpbbxyb.jpg",
      link: "https://vintation.com/theme/674a88e2ed6b7508bbc08f3b",
    },
    {
      image:
        "https://image.invb.my.id/63cbdc410c4fee3502af8aa9/images/1774327541162-zj0sp5sus48.jpg",
      link: "https://vintation.com/theme/674a81e733c8d808a561406e",
    },
    {
      image:
        "https://image.invb.my.id/63cbdc410c4fee3502af8aa9/images/1774327563632-7lab07ho44k.jpg",
      link: "https://vintation.com/theme/675e3c0143487c093f0b8d66",
    },
    {
      image:
        "https://image.invb.my.id/63cbdc410c4fee3502af8aa9/images/1774327585999-e1md6eyg98o.jpg",
      link: "https://vintation.com/theme/674a915e0ce52108a3ab124c",
    },
    {
      image:
        "https://image.invb.my.id/63cbdc410c4fee3502af8aa9/images/1774327608987-fkfstdtplfi.jpg",
      link: "https://vintation.com/theme/6746dd47ed29cb0b1ad1aa24",
    },
    {
      image:
        "https://image.invb.my.id/63cbdc410c4fee3502af8aa9/images/1774327634973-z6lasdruy8j.jpg",
      link: "https://vintation.com/theme/673b1b2dc690ba08b10ac6d5",
    },
  ];
  const movePage = (link) => {
    window.open(link, "_blank");
  };
  return (
    <>
      <div className="container">
        <NavbarComp></NavbarComp>
        <HeroComp></HeroComp>
      </div>
      <Container className="mt-2 mb-2">
        <h1
          className="mitra-title"
          style={{
            fontSize: "58px",
            lineHeight: "1.1",
            marginBottom: "24px",
            color: "#111",
            fontWeight: 800,
          }}
        >
          Banyak pilihan
          <br />
          <span style={{ color: "#ff0a8a" }}>
            {" "}
            Tema berbagai macam kategori
          </span>
        </h1>
        <p
          className="mitra-desc"
          style={{
            fontSize: "18px",
            lineHeight: "32px",
            color: "#666",
            marginBottom: "40px",
          }}
        >
          Mulai dari website undangan pernikahan, aqiqah, ulang tahun, perayaan
          dan lain - lain{" "}
          <span style={{ color: "#ff0a8a" }}>
            Sudah disediakan tema bahkan bisa buat tema sendiri sesuai kemauan
          </span>{" "}
          Pilih tema, edit dan share link dengan mudah
        </p>
        {/* <ThemeShowsComp images={images2}></ThemeShowsComp> */}
      </Container>
      <Container className="mt-4 mb-5">
        {/* <ThemeShowsComp images={images}></ThemeShowsComp> */}
      </Container>
      <MitraComp></MitraComp>
      {/* Trust / Stats */}
      <section className="trust">
        <div className="trust-cards">
          <div className="trust-card">
            <img
              src="https://image.invb.my.id/64b9058e88cc900dc65eb486/1777424413206-icon2.png"
              width="100px"
            />
            <h4>Tanpa Batas</h4>
            <p>Buat undangan unlimited</p>
          </div>
          <div className="trust-card">
            <img
              src="https://image.invb.my.id/64b9058e88cc900dc65eb486/1777424413218-icon1.png"
              width="100px"
            />
            <h4>Mudah Digunakan</h4>
            <p>Tanpa coding, drag & drop</p>
          </div>
          <div className="trust-card">
            <img
              src="https://image.invb.my.id/64b9058e88cc900dc65eb486/1777424413195-icon3.png"
              width="100px"
            />
            <h4>Desain Premium</h4>
            <p>Template elegan & modern</p>
          </div>
          <div className="trust-card">
            <img
              src="https://image.invb.my.id/64b9058e88cc900dc65eb486/1777424413193-icon4.png"
              width="100px"
            />
            <h4>Cloud Hosting</h4>
            <p>Aman, cepat & stabil</p>
          </div>
        </div>
      </section>
      {/* <img src="https://image.invb.my.id/64b9058e88cc900dc65eb486/1779327599780-chatgpt-image-may-21-2026-083815-am-1.png"  className="img-fluid"/> */}
      <FaqComp></FaqComp>
      {/* Footer */}
      <FooterComp></FooterComp>
    </>
  );
}
